import { authHeader, BASE_URL, handleResponse } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnSuccess } from '@helpers/product-events';

export const ringcentralIntegrationService = {
    getAuthorizeUrl,
    connectIntegration,
    disconnectIntegration,
    getPhoneNumbers,
};

function getAuthorizeUrl() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/ringcentral/authorize-url`, requestOptions).then(handleResponse);
}

function connectIntegration(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/ringcentral/connect-integration`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.IntegrationConnected, { integration: 'ringcentral' }));
}

function disconnectIntegration(integrationId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    const query = integrationId ? `?integrationId=${integrationId}` : '';
    return fetch(`${BASE_URL}api/ringcentral/disconnect-integration${query}`, requestOptions).then(handleResponse);
}

function getPhoneNumbers(integrationId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/ringcentral/phone-numbers?integrationId=${integrationId}`, requestOptions).then(
        handleResponse,
    );
}
